import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const ContainerStyle = styled.div`
    user-select: none;
    cursor: pointer;
`;

const ContentStyle = styled.div`
    color: ${props => props.theme.white};
    position: fixed;
    z-index: 999;
    padding: 12px;
    font-size: 12px;
    cursor: default;
    border-radius: 3px;
    white-space: nowrap;
    animation: fadeIn ease-in-out 0.65s;
    box-shadow: 0 4px 5px 3px rgba(0, 0, 0, 0.2);
    background-color: ${props => props.theme.greyDarker};

    .arrow {
        width: 0;
        height: 0;
        position: absolute;
    }
    &.top {
        top: ${props => (props.$rect.top - 44) + "px"};
        left: ${props => (props.$rect.left + (props.$rect.width / 2)) + "px"};
        transform: translateX(-50%);
        .arrow {
            bottom: -8px;
            left: calc(50% - 8px);
            border-left: 8px solid transparent;
            border-right: 8px solid transparent;
            border-top: 8px solid ${props => props.theme.greyDarker};
        }
    }
`;

export const Tooltip = ({ message, position = "top", enabled = true, style = {}, children }) => {
    const tooltipRef = useRef();
    const [isVisible, setVisible] = useState(false);

    const mouseOver = ({ target }) => {
        if (tooltipRef.current !== null && tooltipRef.current.contains(target) && enabled) {
            setVisible(true);
        } else {
            setVisible(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mouseover", mouseOver);
        return () => {
            document.removeEventListener("mouseover", mouseOver);
        };
    }, [enabled]);

    return (
        <ContainerStyle ref={tooltipRef} style={{...style}}>
            <div style={{display: "flex", flexGrow: "1", justifyContent: "center"}}>{children}</div>
            {isVisible && (
                <ContentStyle className={position} $rect={tooltipRef.current.getBoundingClientRect()}>
                    <span className="arrow"></span>
                    {message}
                </ContentStyle>
            )}
        </ContainerStyle>
    );
};